import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

export const HomeCoachingCourse = () => {
  const subjects = [
    "Physics",
    "Chemistry",
    "Biology",
    "Maths",
    "ICT",
    "Computer Science",
    "English",
    "Literature",
  ];

  const highlights = [
    "Experienced educator with teaching experience at NMIMS and VIT.",
    "Friendly, concept-based, and result-oriented teaching style.",
    "Flexible home or online coaching aligned to school curricula.",
  ];

  return (
    <div className="w-full bg-gray-50 min-h-screen">
      <div className="bg-slate-900 text-white py-20 px-4 text-center">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-bold mb-4"
        >
          Home & Online Coaching
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-xl max-w-2xl mx-auto opacity-90"
        >
          Course 5: Coaching for IB, IGCSE, ICSE, and CBSE students.
        </motion.p>
      </div>

      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-primary font-bold tracking-wider uppercase text-sm">Personalized Learning</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-3 mb-6">
              Concept-based coaching that builds confidence
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              We offer home or online coaching for students who need personalized academic support across boards like
               <span className="font-bold"> IB, IGCSE, ICSE, and CBSE.</span> Sessions are tailored to each learner, focusing on deep understanding and
              consistent results.
            </p>

            <div className="space-y-4 mb-8">
              {highlights.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-primary shrink-0" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src="/images/medium-shot-boy-with-laptop_23-2148551604.jpg"
                alt="Student learning online"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-primary font-bold tracking-wider uppercase text-sm">Subjects</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">What we teach</h2>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Strong foundations across core science, math, and language subjects.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {subjects.map((subject) => (
              <div
                key={subject}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow text-center"
              >
                <p className="text-gray-800 font-semibold">{subject}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeCoachingCourse;
